import React from "react";
import About from "../components/About";
import CounterSection from "../components/CounterSection";
import AffiliationSlider from "../components/AffiliationSlider";
import Features from "../components/Features";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <About />
      <CounterSection /> 
      <AffiliationSlider />
      <Features />
      <Footer />
    </>
  );
}

export default Home;